import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  Nav,
  NavItem,
  NavLink,
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
import _navPortal from '../../_navPortal';
import _navEloader from '../../_navEloader';
import _navCounter from '../../_navCounter';
import _navSaleperson from '../../_navSaleperson';
// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { Page404 } from '../../views/Pages';
import { connect } from 'react-redux';
import Dashboard from '../../views/Dashboard/Dashboard';

class DefaultLayout extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeItem: null,
    };
  }

  toggle(item) {
    const activeItem = this.state.activeItem === item ? null : item;
    this.setState({ activeItem });
  }

  render() {
    let { pageFeatures } = this.props.auth;
    console.log(pageFeatures)
    let navItems = { items: [] };
    let filteredRoute = []
    routes.forEach(route => {
      if (route.path === '/' || route.path === '/404' || route.path === '/500' || route.path === '/user/changepassword' || route.path === '/user/myprofile') {
        filteredRoute.push(route);
      }
      pageFeatures.forEach(feature => {
        if (feature.menuType === "ME") {
          if (route.path.toLowerCase().includes(feature.pageURL.toLowerCase()) && route.type === "view" && feature.canView) {
            filteredRoute.push(route)
          }
          if (route.path.toLowerCase().includes(feature.pageURL.toLowerCase()) && route.type === "add" && feature.canAdd) {
            filteredRoute.push(route)
          }
          if (route.path.toLowerCase().includes(feature.pageURL.toLowerCase()) && route.type === "edit" && feature.canEdit) {
            filteredRoute.push(route)
          }
        }
      })
    })
    // console.log("all routes", routes)
    console.log("accessed routes", filteredRoute);
    //create group menu
    pageFeatures.map(feature => {
      if (feature.menuType === "MG") {
        navItems.items.push({ "icon": feature.icon, "menuCode": feature.menuCode, "name": feature.menuName, "isOpen": false, children: [] })
      }
    });
    //create sub menu
    pageFeatures.map(feature => {
      if (feature.menuType === "ME") {
        navItems.items.map(nav => {
          if (nav.menuCode === feature.menuGroupCode) {
            nav.children.push({ "icon": feature.icon, "name": feature.menuName, "url": feature.pageURL })
          }
        });
      }
    });
    return (

      <div className="app">
        <AppHeader fixed>
          <DefaultHeader history={this.props.history} />
        </AppHeader>

        <div className="app-body">
          <AppSidebar fixed display="lg" >
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav 
            navConfig={navItems} 
            {...this.props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            {/* <AppBreadcrumb appRoutes={filteredRoute} /> */}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Container fluid>
              <Switch>
                {filteredRoute.map((route, idx) => {
                  return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                    <route.component {...props} />
                  )} />)
                    : (null)
                },
                )}
                <Redirect to={{ pathname: "/404" }} />
              </Switch>
            </Container>
          </main>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { auth: state.auth };
}
export default connect(mapStateToProps)(DefaultLayout);
